var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[(_vm.viewIcon)?_c('v-icon',{staticClass:"pr-2 pb-1",attrs:{"color":_vm.colorClass}},[_vm._v(_vm._s(_vm.icon.circle))]):_vm._e(),_c('span',{class:_vm.textClass},[_vm._v(_vm._s(_vm.status.descripcion))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }